/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { ReactivateUserOptions, ReactivateUserResponses } from '../types/ReactivateUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Marks the deactivation REACTIVATED and lifts the trading, funding, and transfer blocks. Only stable requests (COMPLETED or FAILED) can be reactivated; a PENDING wind-down must first complete or fail. The audit trail is preserved.
 * @summary Lift a user's account deactivation (admin)
 * {@link /v1/user/:user_id/reactivate}
 */
export function reactivateUser<ThrowOnError extends boolean = true>(
  options: Options<ReactivateUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<ReactivateUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/user/{user_id}/reactivate',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ReactivateUserResponses, ThrowOnError>>,
  )
}
